module.exports = __webpack_public_path__ + "img/img_kb_type2_01.0831a364.png";